import { render, staticRenderFns } from "./FrameEditor.vue?vue&type=template&id=26794a0d&scoped=true"
import script from "./FrameEditor.vue?vue&type=script&lang=js"
export * from "./FrameEditor.vue?vue&type=script&lang=js"
import style0 from "./FrameEditor.vue?vue&type=style&index=0&id=26794a0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26794a0d",
  null
  
)

export default component.exports